import { useI18n } from '../i18n/useI18n'

export function Footer() {
  const { t } = useI18n()

  return (
    <footer className="w-full border-t border-outline-variant bg-surface-container-lowest py-6">
      <div className="mx-auto flex max-w-container-max flex-col items-center justify-between gap-4 px-4 md:flex-row md:px-margin-desktop">
        <div className="font-headline-md text-headline-md font-bold text-primary">
          {t.brand}
        </div>
        <p className="text-center font-label-sm text-label-sm text-on-surface-variant md:text-left">
          {t.footer.copyright}
        </p>
        <nav className="flex flex-wrap justify-center gap-4 md:gap-6">
          <a
            href="#"
            className="font-label-sm text-label-sm text-on-surface-variant underline transition-colors hover:text-primary"
          >
            {t.footer.documentation}
          </a>
          <a
            href="https://github.com/HughYau/AcademicForge"
            target="_blank"
            rel="noopener noreferrer"
            className="font-label-sm text-label-sm text-on-surface-variant underline transition-colors hover:text-primary"
          >
            AcademicForge
          </a>
          <a
            href="https://github.com/K-Dense-AI/scientific-agent-skills"
            target="_blank"
            rel="noopener noreferrer"
            className="font-label-sm text-label-sm text-on-surface-variant underline transition-colors hover:text-primary"
          >
            Scientific Agent Skills
          </a>
          <a
            href="#"
            className="font-label-sm text-label-sm text-on-surface-variant underline transition-colors hover:text-primary"
          >
            {t.footer.privacy}
          </a>
        </nav>
      </div>
    </footer>
  )
}
